// flow weak

import React, {
  PureComponent
}                             from 'react';
import PropTypes              from 'prop-types';
import AnimatedView           from '../../../../components';
import styles                 from './style'
import {
  defaultOptions,
  checkStatus,
  parseJSON,
  getLocationOrigin
}                     from '../../../../services/fetchTools';
import {Link} from 'react-router-dom';
import { withRouter } from 'react-router';
import { Table } from 'reactstrap';


class EditTarget extends PureComponent {
  static propTypes = {
    actions: PropTypes.shape({
      enterPage: PropTypes.func,
      leavePage: PropTypes.func,
    })
  };

  constructor(props) {
    super(props);
    var today = new Date();
    this.state = {
      year:today.getFullYear(),
      month:today.getMonth()+1,
      target_type:'Collection',
      venue_data:{},
      game:{},
      result : {},
      header : [],
      show:false,
      
      months:[1,2,3,4,5,6,7,8,9,10,11,12],
      name:['Active Customers','Revenue','Collection','New Additions','Renewals']
      
    };
  
  this.handleSubmit = this.handleSubmit.bind(this);
	this.handleChangeYear = this.handleChangeYear.bind(this);    
	this.handleChangeMonth = this.handleChangeMonth.bind(this);
	this.handleChangeType = this.handleChangeType.bind(this);
	this.targetUpdated = this.targetUpdated.bind(this);
  }

  componentDidMount() {}


  handleChangeYear(event) {
    this.setState({year: event.target.value});
  }

  handleChangeMonth(event) {
    this.setState({month: event.target.value});
  }

  handleChangeType(event) {
    this.setState({target_type: event.target.value});
  }    

  targetUpdated(event) {
  	// alert('Updated');
    // this.setState({target_type: event.target.value});
    const venue_name = event.target.name.split('_')[1];
    var index = event.target.name.split('_')[0];
    let targets = {...this.state.result};
    // var targets = this.state.result;
    targets[venue_name][index]["value"] = event.target.value;
    this.setState({result: targets});
    console.log(event.target.name);


  }  


  getTarget(year,month,type) {

    this.setState({result:{}})
    // document.getElementsByName("targets_table").innerHTML = "";

    const url = `${getLocationOrigin()}/eagleeye/get_target/?year=${year}&month=${month}&name=${type}`;
    const options = {...defaultOptions};

    fetch(url, options)
      .then(checkStatus)
      .then(parseJSON)
      .then(data =>{  
      		this.setState({result:data.result,
      						header:data.games});

      		// this.setState({id: data.id, value: data.value, venue:data.venue,game:data.game});
      		console.log(this.state.result); 
      		this.setState({show:true});
    									                // first then()
      })
      .catch(error => {
        console.log(error);
        alert(error.Message);
      });

  }

  updateTargets(result) {
  	const url = `${getLocationOrigin()}/eagleeye/update_targets/`;
  	const options = {...defaultOptions};
  	options['method'] = 'post';
  	options['headers'] = {'content-type': 'application/json'}
    options['body'] = JSON.stringify(result);
    console.log(result);
    console.log('Going to fetch');
    return fetch(url, options)
    .then(checkStatus)
    .then(parseJSON)
    .then((response) => {
    	alert(response.message);
    })
    .catch(error => {
    console.log(error);
    alert(error.message);
                });
  }

  handleSubmit(event) {
    event.preventDefault();
    this.updateTargets(this.state.result);
    console.log('Submit');
    console.log('post');
    console.log(this.state);
  }

  render() {
  	var row_sum = {};
  	var col_sum = {};
  	var sum_of_row = [];
  	var total_sum = 0;
  	let res = {...this.state.result};
  	for (var key in res){
  		row_sum[key] = 0;
  		for (var each in res[key]){
  			// console.log(res[key][each]['value']);
  			col_sum['Total'] = 'Total';
  			var val = res[key][each]['value'];
  			var game_type = res[key][each]['game_type'];
  			if (!col_sum[game_type]){
  				col_sum[game_type] = 0;
  			}
  			if (val == '' || val == null){
  				val = 0;
  			}
  			total_sum += Number(val);
  			row_sum[key] += Number(val);
  			col_sum[game_type] += Number(val);	
  		}
  		col_sum['Total Sum'] = total_sum;
  		sum_of_row.push(row_sum[key]);
  		
  	}

  	console.log(row_sum);
  	console.log(col_sum);

    return(
      <div style={styles.container}>
        <div className="table-bordered" style={styles.table}>
          <div style={styles.main_header} className="col-md-12">
            <h3 style={{textAlign:'center'}}>Edit Target</h3>
          </div>
          <div style={styles.items} className="col-md-12">
                  <div style={styles.item_header} className="col-md-4">
                    Year
                  </div>
                  <select name="year" className="col-md-8" style={styles.item_body} value={this.state.year}
                    onChange={this.handleChangeYear}>
                   

                      <option key={3} value={2019}>{2019}</option>
                      <option key={4} value={2020}>{2020}</option>
                     
                  </select>
                </div>	

           <div style={styles.items} className="col-md-12">
                  <div style={styles.item_header} className="col-md-4">
                    Month
                  </div>
                  <select name="month" className="col-md-8" style={styles.item_body} value={this.state.month}
                    onChange={this.handleChangeMonth}>

                    {	
                      this.state.months.map((x,index) =>
                      <option key={x} value={x}>{x}</option>
                      		)
                      }
                  </select>
                </div>

             <div style={styles.items} className="col-md-12">
                  <div style={styles.item_header} className="col-md-4">
                    Type
                  </div>
                  <select name="type" className="col-md-8" style={styles.item_body} value={this.state.target_type}
                    onChange={this.handleChangeType}>
                   
                    {
                      this.state.name.map((x,index) =>
                      <option key={x} value={x}>{x}</option>
                      		)
                      }
                  </select>
                </div>	

              <div style={styles.button_submit} className="col-md-12">
                  <input className="btn btn-lg" type="submit" value="Show Values" onClick={() => this.getTarget(this.state.year,this.state.month,this.state.target_type)} style={{
                      backgroundColor:'#302C35',
                      backgroundColor:'#009688',
                      color:'#ffffff'
                  }}/>
                </div>	
           </div>


           { this.state.result && 
           <div   style={styles.item_table}>
           		  <Table name="targets_table">
           		  <tr >
           		  { 	
           		  	this.state.header.map((key, index) => 
           		  	<th style={styles.main_header} key={index} value={key}> {key} </th>
           		  )
           		}
           		  </tr>
           		  {	
	                  	Object.keys(this.state.result).map((key, index) => (

		                  <tr style={styles.item_body} key={index} value={key}>
	                  			<td style={styles.items}>
	                  				{key}
	                  			</td>

	                  			{
			                  		this.state.result[key].map((gametype,index) => 
			                  			<td >
			                  				<input name={index + '_' + key} style={styles.input}  index={index} type="text" value={gametype.value} onChange={this.targetUpdated} />
			                  			
			                  			</td>

			                  		)
		                  		}

					               		<td style={styles.col_sum}>
					               			<p key={index} value={sum_of_row[index]}>{sum_of_row[index]} </p>
					               		</td>	
		                  			
		                  </tr>
	                  ))
                  }

                  <tr style={styles.item_body}>
                  {
                  		Object.keys(col_sum).map((key,index) => (
                  			<td style={styles.col_sum}>
                  					<p key={index} value={col_sum[key]}> {col_sum[key]}</p>
                  				</td>
                  			))
                  	}
                  	</tr>
                  
				</Table>
				</div>
			}

			{	this.state.show &&
				<div style={styles.button_submit} >
                  <input className="btn btn-lg" type="submit" value="Update Targets" onClick={this.handleSubmit} style={{
                      backgroundColor:'#302C35',
                      backgroundColor:'#009688',
                      color:'#ffffff'
                  }}/>
                </div>	
            }
      </div>
    );
  }
}

export default EditTarget;




// WEBPACK FOOTER //
// ./src/app/views/partner/crud/editTarget/index.js